import { defPageSize } from "../../constants/events";
import { z } from "zod";

export const userFiltersCacheKey = "USER_FILTERS_CACHE_KEY";

export interface UserFilters {
  group_ids?: number[];
  active?: boolean;
  role_ids?: number[];
  rangs?: number[];
  search_in_subgroup?: boolean; 
  date_employed_min?: string;
  date_employed_max?: string;
  date_unemployed_min?: string;
  date_unemployed_max?: string;
  searchQuery?: string;
  limit?: number;
  offset?: number;
  sortDirection?: "ASC" | "DESC"; // Новое поле для направления сортировки
}

export const userFiltersSchema = z.object({
  group_ids: z.array(z.number()).optional(),
  active: z.boolean().optional(),
  role_ids: z.array(z.number()).optional(),
  rangs: z.array(z.number()).optional(),
  search_in_subgroup: z.boolean().optional(),
  date_employed_min: z.string().optional(),
  date_employed_max: z.string().optional(),
  date_unemployed_min: z.string().optional(),
  date_unemployed_max: z.string().optional(),
  searchQuery: z.string().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
  sortDirection: z.enum(["ASC", "DESC"]).optional(), // Новое поле для направления сортировки
});

export type UserFiltersSchema = z.infer<typeof userFiltersSchema>;

export const defaultUserListFilters: UserFilters = {
    active: true,
    sortDirection: "DESC",
    offset: 0,
    limit: defPageSize,
    search_in_subgroup: true
}

